import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../../common/hooks/useAuth";
import { Storage } from "../../common/utils/Storage";

import { selectSettingsLoaded, selectLoginInCheckout } from '../../common/store/settingsSlice';
import { selectIsLoadingUserLocations, selectUserHasLocations, selectUserLocationsFailed, selectUserLocationsNotRequested } from '../../common/store/locationsSlice';
import { getCategories } from '../../common/store/categoriesSlice';
import { getReturnKey } from '../../common/store/cartSlice';
import { UserLocationsLoadError } from './UserLocationsLoadError';

export const ProtectedLayout = () => {
    const { token } = useAuth();
    const dispatch = useDispatch();
    const settingsLoaded = useSelector(selectSettingsLoaded);
    const loginOnlyInCheckout = useSelector(selectLoginInCheckout);
    const isLoadingUserLocations = useSelector(selectIsLoadingUserLocations);
    const userHasLocations = useSelector(selectUserHasLocations);
    const userLocationsFailed = useSelector(selectUserLocationsFailed);
    const userLocationsNotRequested = useSelector(selectUserLocationsNotRequested);
    const location = useLocation();

    useEffect(() => {
        if(loginOnlyInCheckout) {
            dispatch(getCategories());
            dispatch(getReturnKey());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsLoaded])

    const isIAMUser = Storage.isIAMUser();
    // IAM users load their locations only after the IAM login in LoginView completes
    const waitsForUserLocations = token && isLoadingUserLocations && !(isIAMUser && userLocationsNotRequested);

    if (!settingsLoaded || waitsForUserLocations) {
        return null;
    }

    if (token && userLocationsFailed) {
        return <UserLocationsLoadError />;
    }

    const hasCredentials = token && userHasLocations;

    if (!hasCredentials && !loginOnlyInCheckout) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return (
        <div>
            <Outlet />
        </div>
    );
};
